// extracted by mini-css-extract-plugin
module.exports = {"brandcolor":"#163194","brandcolor2":"#2699FB","mainbackgroundcolor":"#fff","root":"H_bk","filled":"H_cy","input-area":"H_cz","inputArea":"H_cz","label":"H_ct"};